import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { GroupFollowUserCourses, GroupFollowUserSummary } from '.';

const GroupFollowUser = () => {
  const {
    pageState: { group, userId }
  } = useReduxState();

  const { data, loading } = useApiData({
    url: `/admin/groups/${group.id}/participants?userId=${userId}`
  });

  return (
    <div className="user">
      <div className="summary">
        <GroupFollowUserSummary
          loading={loading}
          targetUser={data?.users?.[0]}
        />
      </div>

      <div className="courses">
        <GroupFollowUserCourses
          courses={data?.courses}
          coursesProgressData={data?.users?.[0]?.progressData?.courses}
          loading={loading}
        />
      </div>

      <style jsx>{`
        .courses {
          margin-top: 20px;
        }
      `}</style>
    </div>
  );
};

export default GroupFollowUser;
